import React/*, {Component}*/ from 'react';
//import PropTypes from 'prop-types';


export default class Tabs extends React.Component {
	//constructor(props){
	//	super(props);
	//}
	
	state = {
		activeTab: 0
	}
	render(){
		return (
			<nav className="tab-nav">
				{this.props.children}
				
			</nav>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Tabs.js